import * as actionTypes from './actionTypes';

export const setModal = (payload) => {
    return dispatch => {
        dispatch({
            type: actionTypes.SET_MODAL,
            action: payload
        });
    };
};